import React from 'react';
import { Button } from 'reactstrap';
import CircleSpinner from 'common/components/circleSpinner';
import { DEMO } from 'permissions/constants';
import UserTypeForbidden from 'permissions/components/userTypeForbidden';
import AuthenticationForbidden from 'permissions/components/authenticationForbidden';
import logInIcon from 'assets/icons/log-in.svg';
import demoIcon from 'assets/icons/presentation.svg';
import companyIcon from 'assets/icons/office.svg';
import startupIcon from 'assets/icons/rocket.svg';
import fundManagerIcon from 'assets/icons/loan.svg';

import useLandingAuthButtons from './useLandingAuthButtons';
import './index.scss';

const LandingAuthButtons = () => {
  const {
    loginDemo,
    loginStarted,
    pushAuthLocationWithRedirect,
  } = useLandingAuthButtons();

  return (
    <div className="landing-hero__buttons">
      <AuthenticationForbidden>
        <Button
          color="primary"
          className="log-in-button-square"
          onClick={() => pushAuthLocationWithRedirect('/watchlist')}
        >
          <img src={logInIcon} alt="log in" />
          <br />
          Log in
        </Button>
        <Button
          className="log-in-button-square"
          onClick={loginDemo}
          color="primary"
          disabled={loginStarted}
        >
          {loginStarted ? (
            <CircleSpinner
              className="landing-hero__demo-spinner"
              color="#FFFFFF"
            />
          ) : (
            <img src={demoIcon} alt="demo" />
          )}
          <br />
          Demo account
        </Button>
      </AuthenticationForbidden>
      <UserTypeForbidden userType={DEMO}>
        <Button
          className="log-in-button-square"
          color="primary"
          onClick={() => pushAuthLocationWithRedirect('/admin/company/create')}
        >
          <img src={companyIcon} alt="company" />
          <br />
          Add your listed 
          {' '}
          <br />
          company
        </Button>
        <Button
          className="log-in-button-square"
          color="primary"
          onClick={() => pushAuthLocationWithRedirect('/admin/startup/create')}
        >
          <img src={startupIcon} alt="startup" />
          <br />
          Add your startup
        </Button>
        <Button
          className="log-in-button-square"
          color="primary"
          onClick={() =>
            pushAuthLocationWithRedirect('/admin/fundsmanager/create')}
        >
          <img src={fundManagerIcon} alt="fund-manager" />
          <br />
          Add your 
          {' '}
          <br />
          fund-manager
        </Button>
      </UserTypeForbidden>
    </div>
  );
};

export default LandingAuthButtons;
